import setBreakpoint from './setBreakpoint.js';
import getBreakpoint from './getBreakpoint.js';
export default {
  setBreakpoint,
  getBreakpoint
};


// WEBPACK FOOTER //
// ./node_modules/swiper/core/breakpoints/index.js